import { render, staticRenderFns } from "./CategoryDetails.vue?vue&type=template&id=0758add2&scoped=true"
import script from "./CategoryDetails.vue?vue&type=script&lang=ts"
export * from "./CategoryDetails.vue?vue&type=script&lang=ts"
import style0 from "./CategoryDetails.vue?vue&type=style&index=0&id=0758add2&lang=scss"
import style1 from "./CategoryDetails.vue?vue&type=style&index=1&id=0758add2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0758add2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0758add2')) {
      api.createRecord('0758add2', component.options)
    } else {
      api.reload('0758add2', component.options)
    }
    module.hot.accept("./CategoryDetails.vue?vue&type=template&id=0758add2&scoped=true", function () {
      api.rerender('0758add2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/category/components/CategoryDetails.vue"
export default component.exports